import React, { useContext, useEffect, useState, useRef } from 'react'
import Layout from '../Layouts/Layout'
import ModalLayoutNew from '../Modals/ModalLayoutNew'
import NewAppraisalModal from '../Modals/NewAppraisalModal'
import CQMenu from './CQMenu'
import CiqHeader from './CiqHeader'
import { LeadsContext } from "../Context/LeadsContext";
import CallBackClientsCalender from './CallBackClientsCalender'
import CustomerTable from './CustomerTable'
import AppraisalDetails from './AppraisalDetails'
import WebAppointmentsTable from './WebAppointmentsTable'
import { useLocation, useNavigate } from 'react-router-dom'
import { getImages } from '../Const'
import Marquee from "react-fast-marquee";

const CustomersInQueue = () => {
    const location = useLocation();
    const { getLeads, isInitialLoad, leadData, filteredLeads, filteredSMLeads, leadSearch, activeLeadID, getAnnouncements, allLeads, leadsLoading, searchText } = useContext(LeadsContext);

    const [openLead, setOpenLead] = useState("");

    const [appraisalData, setAppraisalData] = useState({});

    const [openNewAppraisal, setOpenNewAppraisal] = useState(false);
    const [loading, setLoading] = useState(true);
    const handleNewAppraisal = () => {
        setOpenNewAppraisal(true);
        document.body.classList.add('overflow-body');
    }
    const closeNewAppraisal = () => {
        setOpenNewAppraisal(false);
        document.body.classList.remove('overflow-body');
    }

    const [appraisalStage, setAppraisalStage] = useState("");

    const closeModal = () => {
        setAppraisalStage("");
    }

    const handleAppraisalDetails = (lead) => {
        const tabData = {
            location: lead.location,
            stage: (lead.appointment_date ? "WebAppointments" : lead.appraisal_stage) || activeTab.stage,
            lead_type: lead.lead_type || activeTab.lead_type,
            status: ""
        };

        // console.log(lead, tabData);
        setAppraisalData(lead);
        setAppraisalStage(lead.appraisal_stage || "Completed");
        setOpenLead(lead.id);

        //storeTabData(tabData);
    }

    useEffect(() => {
        setAppraisalData(filteredLeads.find((lead) => lead.id == openLead));
    }, [filteredLeads])

    //   Selected Dropdown
    const [activeTab, setActiveTab] = useState(() => {
        const storedValue = localStorage.getItem('activeTab');
        return storedValue && storedValue != "undefined" ? JSON.parse(storedValue) : {
            location: 'POMPANO BEACH',
            stage: 'InQueue',
            lead_type: 'InPerson',
            status: '',
            title: "Appraisals in Queue"
        }
    });

    const handleLeadTypeSelect = (location, stage, lead_type, status = "") => {

        setLoading(true); 
        storeTabData({
            location: location,
            stage: stage,
            lead_type: lead_type,
            status: status,
            title: getLeadTitle(stage,status)
        });

        requestAnimationFrame(() => {
            setLoading(false);
        });
    };

    const storeTabData = (tabData) => {
        setActiveTab(tabData);
        localStorage.setItem('activeTab', JSON.stringify(tabData));
    }

    const getLeadTitle = (stage,status="") => {
        let title = "Appraisals in Queue";
        switch (status || stage) {
            case "InQueue": title = "Appraisals in Queue"; break;
            case "InProgress": title = "Appraisals in Progress"; break;
            case "Completed": title = "Completed Appraisals"; break;
            case "Callback": title = "CallBack Clients"; break;
            case "Bought": title = "Bought Vehicles"; break;
            case "WebAppointments": title = "Web Appointments"; break;
        }

        return title;
    }

    useEffect(() => {
        console.log("active lead ID", activeLeadID, filteredLeads);

        var foundLead = leadData.filter((lead) => lead.id == activeLeadID);
        
        if(foundLead.length) {
            foundLead = foundLead[0];
            console.log("found it", foundLead);
            handleAppraisalDetails(foundLead);

            storeTabData({
                location: foundLead.lead_type == "EQR" || foundLead.lead_type == "KBB" ? "EQR" : foundLead.location,
                stage: foundLead.appraisal_stage || activeTab.stage,
                lead_type: foundLead.lead_type || activeTab.lead_type,
                status: "",
                title: getLeadTitle(foundLead.appraisal_stage)
            });
        };

        var foundLead = filteredSMLeads.filter((lead) => lead.id == activeLeadID);
        
        if(foundLead.length) {
            foundLead = foundLead[0];
            console.log("found it", foundLead);
            handleAppraisalDetails(foundLead);

            storeTabData({
                location: foundLead.location,
                stage: "Completed",
                lead_type: "InPerson",
                status: "",
                title: getLeadTitle("Completed")
            });
        };
    }, [leadSearch, activeLeadID, allLeads]);

    const scrollRef = useRef(null);

    useEffect(() => {
        if (scrollRef.current && activeTab.stage == "Callback") {
            setTimeout(() => {
                scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
                // console.log("scrolling");
            }, "200");
        }
    }, [activeTab.stage]);

    // customers-in-queue Add Class in Body
    useEffect(() => {
        if (location.pathname === '/store') {
            document.body.classList.add('ciq-page');
        } else {
            document.body.classList.remove('ciq-page');
        }
        return () => {
            document.body.classList.remove('ciq-page');
        };
    }, [location.pathname]);

    // Task Details
    const [openAppraisalModal, setOpenAppraisalModal] = useState(false);
    const [openAppraisalDetails, setOpenAppraisalDetails] = useState("");

    const closeAppraisalDetails = () => {
        setOpenAppraisalModal(false);
        document.body.classList.remove('overflow-body');
    }

    const [announcements, setAnnouncements] = useState([]);

    const fetchAnnouncements = async () => {
        const data = await getAnnouncements();

        var today = new Date();

        setAnnouncements(data.filter((v) => new Date(v.expiration) > today));
    }

    useEffect(() => {
        if(!isInitialLoad) {
            getLeads(true,true);            
        }

        fetchAnnouncements();
    }, []);

    
    useEffect(() => {
        if (
            (activeTab.stage === "WebAppointments" && leadData?.length) ||
            (activeTab.stage !== "WebAppointments" && filteredLeads?.length)
        ) {
            setLoading(false);
        }
    }, [activeTab, leadData, filteredLeads]);

    return (
        <>
            {/* {console.log("activeTab", activeTab)} */}
            <Layout hideTopBar="true">
                <div className='main-block ciq-main-block ciq-main-page'>
                    <div className='container-fluid'>
                        <div className='d-flex cq-flex'>
                            {announcements && announcements.length > 0 && 
                                <div className='cl-scroll-box announcement-box d-lg-none mb-3'>
                                    <div className='honk-icon'>
                                        <img alt='honk-icon' src={getImages('announcement-icon.png')} />
                                    </div>
                                    <div className="marquee-items">
                                        <Marquee gradient={false} speed={80} pauseOnHover={false}>
                                            {announcements.map((v, i) => (
                                                <div className="marquee-scrolling-items" key={i}>
                                                    <span className='hsi-circle'>{i + 1}</span> {v.announcement}
                                                </div>
                                            ))}
                                        </Marquee>
                                    </div>
                                    <div className='view-all-box'>
                                        {/* <button type='button' className='ac-transparent-btn'>View All</button> */}
                                    </div>
                                </div>
                            }
                            <div className='cq-left d-none d-lg-block'>
                                <CQMenu
                                    handleNewAppraisal={handleNewAppraisal}
                                    handleLeadTypeSelect={handleLeadTypeSelect}
                                    activeTab={activeTab}
                                />
                            </div>
                            <div className='d-lg-none px-3 px-lg-0'>
                            <div className="dropdown ad-dropdown ca-menu-list mb-md-4 mb-3">
                                <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {activeTab.title}
                                </button>
                                <ul className="dropdown-menu">
                                    <CQMenu
                                        handleNewAppraisal={handleNewAppraisal}
                                        handleLeadTypeSelect={handleLeadTypeSelect}
                                        activeTab={activeTab}
                                    />
                                </ul>
                            </div>
                            </div>
                            <div className='cq-right customer-queue-right'>
                                <div ref={scrollRef}>
                                    <div className="tab-content" id="myTabContent11">
                                        {announcements && announcements.length > 0 && <div className='cl-scroll-box announcement-box d-none d-lg-block mb-4'>
                                            <div className='honk-icon'>
                                                <img alt='honk-icon' src={getImages('announcement-icon.png')} />
                                            </div>
                                            <div className="marquee-items">
                                                <Marquee gradient={false} speed={80} pauseOnHover={false}>
                                                    {announcements.map((v, i) => (
                                                        <div className="marquee-scrolling-items" key={i}>
                                                            <span className='hsi-circle'>{i + 1}</span> {v.announcement}
                                                        </div>
                                                    ))}
                                                </Marquee>
                                            </div>
                                            <div className='view-all-box'>
                                                {/* <button type='button' className='ac-transparent-btn'>View All</button> */}
                                            </div>
                                        </div>}
                                        {/* Appraisals in Queue */}
                                        {/* {NewLead} */}
                                        <div className="tab-pane fade show active" >
                                            <CiqHeader
                                                title={activeTab.title}
                                                handleNewAppraisal={handleNewAppraisal}
                                                location={activeTab.location}
                                            />
                                            {loading ? 
                                                <div className='loading-cardrop-box'>
                                                    <img className='loading-cardrop-image' src={getImages('loading-cardrop.gif')} alt=''/>
                                                    <div className='xs-title text-center text-gray text-uppercase font-1em'>Appraisals Currently Loading...</div>
                                                </div>
                                            :
                                                <>
                                                    {activeTab.stage === "WebAppointments" ? (
                                                        <WebAppointmentsTable
                                                            leadAction={handleAppraisalDetails}
                                                            leadData={leadData.filter((lead) => lead.appointment_date)}
                                                        />
                                                    ) : (
                                                        <>
                                                            {filteredLeads && activeTab.stage !== "Callback" && (
                                                                <CustomerTable
                                                                    leadAction={handleAppraisalDetails}
                                                                    leadData={filteredLeads //.filter((lead) => (activeTab.stage == "Completed" && activeTab.status == "" && lead.status != "Bought") || activeTab.status != "")
                                                                        .filter((lead) => (lead.appraisal_stage == "InQueue" && !lead.appointment_date) || lead.appraisal_stage != "InQueue")
                                                                        .filter(lead =>
                                                                            (lead.appraisal_stage === activeTab.stage ||
                                                                                (activeTab.stage === "Completed" && lead.appraisal_stage === "Callback")) &&
                                                                            (lead.location === activeTab.location || activeTab.location === "all" || activeTab.location === "EQR") &&
                                                                            (lead.lead_type === activeTab.lead_type || (activeTab.lead_type === "EQR" && lead.lead_type === "KBB")) &&
                                                                            (activeTab.status == "" || lead.status == activeTab.status)
                                                                    ).concat(activeTab.stage == "Completed" ? filteredSMLeads.filter((lead) => lead.location == activeTab.location) : []).sort((a,b) => b.appraisal_date_obj - a.appraisal_date_obj)}
                                                                    leadStage={activeTab.stage}
                                                                    allLeads={allLeads}
                                                                    leadStatus={activeTab.status}
                                                                    setLoading={setLoading}
                                                                    leadsLoading={leadsLoading}
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                    {filteredLeads && activeTab.stage === "Callback" && activeTab.stage !== "WebAppointments" && <CallBackClientsCalender
                                                        leadAction={handleAppraisalDetails}
                                                        leadLocation={activeTab.location}
                                                        leadData={filteredLeads.filter(lead => lead.callback_date_obj && lead.status == "Available" && (lead["location"] == activeTab.location || activeTab.location == "all" || activeTab.location == "EQR") && (lead['lead_type'] == activeTab.lead_type || (activeTab.lead_type == "EQR" && lead['lead_type'] == "KBB")))}
                                                    />}
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
            
            <ModalLayoutNew open={openNewAppraisal} close={closeNewAppraisal} darkThemeCls='true' modalWidth={1198}>
                <NewAppraisalModal
                    close={closeNewAppraisal}
                    appraisalStage={"InQueue"}
                    leadType={"InPerson"}
                />
            </ModalLayoutNew>


            {/* Appraisal Callback */}
            
            <ModalLayoutNew open={appraisalStage && appraisalStage != ""} close={closeModal} darkThemeCls='true' modalWidth={1198}>
                {<AppraisalDetails
                    close={closeModal}
                    appraisalData={appraisalData}
                    appraisalStage={appraisalStage}
                />}
            </ModalLayoutNew>
            
        </>
    )
}

export default CustomersInQueue